export const messages = {
  'collaborationPage.notAvailable':
    'Collaboration management coming soon to WEAVR.\n Please contact info@pacelabweavr.com for more info.',
  'collaborationPage.placeholderAlt':
    'Collaboration management coming soon to WEAVR.\n Please contact info@pacelabweavr.com for more info.',
}
